enum Routes {
  Default = '/',
  Login = '/login',
  SignInRedirect = '/signin-redirect',
  SignOutRedirect = '/signout-redirect',
  Tenants = '/tenants',
  Organisation = '/organisation',
  Residents = '/residents',
  ResidentsSettings = 'residentssettings',
  ResidentsChangeLog = 'residentschangelog',
  Roles = '/roles',
  History = '/history',
  FaultsHistory = '/faultsHistory',
  Dashboard = '/dashboard',
  AppInformation = '/appInformation',
  Integrations = '/integrations',
  IntegrationsDevices = 'devices',
  IntegrationsSystems = 'systems',
  IntegrationsGateways = 'gateways',
  IntegrationsConnectors = 'connectors',
  TemporaryAccess = '/temporaryAccess',
  Settings = '/settings',
  SettingsExplanationLink = 'explanationLink',
  SettingsEmergencyAlarm = 'emergencyAlarm',
  SettingsCareConnect = 'settingsCareConnect',
  SettingsWanderingBoundaries = 'wanderingboundaries',
  SettingsMalfunctionNotifications = 'malfunctionnotifications',
  SettingsMediaserverSwitch = 'media',
  FeatureSubscriptions = '/featureSubscriptions',
}

export default Routes;
